// // hooks/useParentPoolAPR.js
// hooks/useParentPoolAPR.js
import { useMemo, useEffect, useState, useCallback } from 'react';
import { calculateAPR2 } from '../utils/unifarmAprCalculator';
import { calculateChildPoolAPR2 } from '../utils/unifarmAprCalculator';
import { useRootTotalBond } from './totalBond';
import { useTVL } from './useTVL';
import { useBondSize } from './useBondSize';

export const useParentPoolAPR = (contractAddress, rewardAmount, poolEndDate, childContractAddr = null, createdAt) => {
    // console.log(contractAddress, rewardAmount, poolEndDate, 'contractAddress, rewardAmount, poolEndDate');

    const { rawTvl } = useTVL(contractAddress, 'rootPool');
    const { rawTvl: childRawTvl } = useTVL(childContractAddr, childContractAddr ? 'childPool' : null);
    const { bondSize } = useRootTotalBond(contractAddress);
    const { bondSize: getBondSize } = useBondSize();

    const [childBondSize, setChildBondSize] = useState(0);

    // Memoized function to fetch child bond size
    const fetchChildBondSize = useCallback(async () => {
        if (childContractAddr) {
            try {
                const result = await getBondSize(childContractAddr);
                setChildBondSize(result);
            } catch (err) {
                console.error('Error fetching child bond size:', err);
                setChildBondSize(0);
            }
        } else {
            setChildBondSize(0);
        }
    }, [childContractAddr]);

    useEffect(() => {
        fetchChildBondSize();
    }, [fetchChildBondSize]);

    // Memoized APR calculation
    const apr = useMemo(() => {
        return calculateAPR2(rewardAmount, rawTvl, bondSize?.raw, poolEndDate, createdAt);
    }, [rewardAmount, rawTvl, bondSize?.raw, poolEndDate, createdAt]);

    // Memoized child pool APR calculation
    const childPoolAPR = useMemo(() => {
        if (!childContractAddr) {
            return 0;
        }

        return calculateChildPoolAPR2(
            childRawTvl,      // TVL_i (child pool TVL)
            childBondSize,    // Bond_i (child pool bond)
            rawTvl,           // TVL_j (root pool TVL)
            bondSize?.raw,    // Bond_j (root pool bond)
            apr               // parent APR
        );
    }, [childContractAddr, childRawTvl, childBondSize, rawTvl, bondSize?.raw, apr]);

    return useMemo(() => ({
        apr,
        childPoolAPR,
        bondSize,
        childBondSize,
        rawTvl,
        childRawTvl
    }), [apr, childPoolAPR, bondSize, childBondSize, rawTvl, childRawTvl]);
};
// import { useMemo, useEffect, useState } from 'react';
// import { calculateAPR2 } from '../utils/unifarmAprCalculator';
// import { calculateChildPoolAPR2 } from '../utils/unifarmAprCalculator';
// import { useRootTotalBond } from './totalBond';
// import { useTVL } from './useTVL';
// import { useBondSize } from './useBondSize';

// export const useParentPoolAPR = (contractAddress, rewardAmount, poolEndDate, childContractAddr = null, createdAt) => {
//     // console.log(contractAddress, rewardAmount, poolEndDate, 'contractAddress, rewardAmount, poolEndDate');

//     const { rawTvl } = useTVL(contractAddress, 'rootPool');
//     const { rawTvl: childRawTvl } = useTVL(childContractAddr, childContractAddr ? 'childPool' : null);
//     const { bondSize } = useRootTotalBond(contractAddress);
//     const { bondSize: getBondSize } = useBondSize();

//     const [childBondSize, setChildBondSize] = useState(0);

//     useEffect(() => {
//         if (childContractAddr) {
//             getBondSize(childContractAddr).then(result => {
//                 setChildBondSize(result);
//             }).catch(err => {
//                 console.error('Error fetching child bond size:', err);
//                 setChildBondSize(0);
//             });
//         } else {
//             setChildBondSize(0);
//         }
//     }, [childContractAddr, getBondSize]);

//     const apr = useMemo(() => {
//         return calculateAPR2(rewardAmount, rawTvl, bondSize?.raw, poolEndDate, createdAt);
//     }, [rewardAmount, rawTvl, bondSize?.raw, poolEndDate]);

//     const childPoolAPR = useMemo(() => {
//         // Only calculate if childContractAddr is present
//         if (!childContractAddr) {
//             return 0;
//         }

//         // child pool = i, root pool = j
//         return calculateChildPoolAPR2(
//             childRawTvl,      // TVL_i (child pool TVL)
//             childBondSize,    // Bond_i (child pool bond)
//             rawTvl,           // TVL_j (root pool TVL)
//             bondSize?.raw,    // Bond_j (root pool bond)
//             apr               // parent APR
//         );
//     }, [childContractAddr, childRawTvl, childBondSize, rawTvl, bondSize?.raw, apr]);

//     return {
//         apr,
//         childPoolAPR,
//         bondSize,
//         childBondSize,
//         rawTvl,
//         childRawTvl
//     };
// };